function Answered(props) {
  return (
    <div className="MoreInfo">
      {props.correct ? (
        <p>
          {props.close ? <b>Close! </b> : <b>Correct! </b>}
          {props.explanation}
        </p>
      ) : (
        <p>
          <b>Incorrect!</b> {props.explanation}
        </p>
      )}
      {props.link && (
        <a href={props.link} target="_blank" rel="noreferrer noopener">
          Read more! &rarr;
        </a>
      )}
    </div>
  );
}

export default Answered;
